/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type ItemImage_item$ref = any;
export type ItemImage_item = {
    readonly photos: ReadonlyArray<{
        readonly largePath: string | null;
        readonly masterOrZoomPath: string | null;
    } | null> | null;
    readonly " $refType": ItemImage_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ItemImage_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "photos",
      "storageKey": "photos(limit:1)",
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1
        }
      ],
      "concreteType": "ItemPhoto",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "largePath",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "masterOrZoomPath",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'ac623e9debde02ce16cb13d0d6afc312';
export default node;
